<script lang="ts">
  import {userContainer} from "$lib/stores/stores.svelte"
  import {cartContainer, loadSavedCart, checkoutUrl} from "$lib/stores/Cart.svelte"
	import { onMount } from "svelte";
  import { fade, scale, slide } from 'svelte/transition'; // Import fade transition
    import { flip } from 'svelte/animate';   // Import flip animation
	import CartLine from "./CartLine.svelte";
  import { m } from "$lib/paraglide/messages";
  import { localizeHref } from "$lib/paraglide/runtime";


onMount(() => {
    loadSavedCart()
  })
  
  let lines = $derived(cartContainer.cart?.lines.edges ?? []);
</script>

<div
  class="w-80 max-h-[70vh]
  bg-white dark:bg-gray-800
  text-gray-900 dark:text-gray-100
  border border-gray-300 dark:border-gray-600
  rounded-lg shadow-2xl
  overflow-hidden
  flex flex-col"
  aria-modal="true"
  role="dialog"
  tabindex="-1"
>
  <!-- Header -->
  <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-gray-700">
    <h2 class="text-sm font-medium">{m.bag()}</h2>
    <button onclick="{()=>userContainer.showingCartPopup = false}" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition">
      <span class="sr-only">Close cart</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  </div>

  <!-- Cart items -->
  <div class="flex-1 overflow-y-auto px-4">
    {#if lines.length === 0}
      <p class="py-8 text-center text-sm text-gray-500 dark:text-gray-400">{m.cart_empty()}</p>
    {:else}
      <ul class="divide-y divide-gray-200 dark:divide-gray-700">
        {#each lines as { node } (node.id)}
        <li
          in:scale={{ duration: 300 }}
          out:fade={{ duration: 250 }}
          animate:flip={{ duration: 500 }}
        >
          <CartLine {node} compact={true} />
        </li>
        {/each}
      </ul>
    {/if}
  </div>

  <!-- Footer -->
  <div class="px-4 py-4 border-t border-gray-200 dark:border-gray-700 space-y-2">
    <a
      href={localizeHref("/cart")}
      class="block w-full rounded border border-gray-300 dark:border-gray-600 px-4 py-2.5 text-sm text-center text-gray-700 dark:text-gray-200 transition hover:bg-gray-50 dark:hover:bg-gray-700"
      style="view-transition-name: view-cart;"
    >
      {m.show_cart()} ({cartContainer.cart?.lines.edges.length ?? 0})
    </a>

    <a
      href="{checkoutUrl()}"
      class="block w-full rounded bg-gray-800 dark:bg-gray-600 px-4 py-2.5 text-sm text-center text-white transition hover:bg-gray-700 dark:hover:bg-gray-500"
      style="view-transition-name: checkout;"
    >
      {m.checkout()}
    </a>
  </div>
</div>